import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, forkJoin } from 'rxjs';
import { PortalBuilderService } from 'src/app/shared/services/administratior-service/portal-builder.service';
import { CustomerService } from 'src/app/shared/services/customer-services/customer.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-customer-profile',
  templateUrl: './customer-profile.component.html',
})
export class CustomerProfileComponent implements OnInit, OnDestroy {
  customerBasicForm!: FormGroup;
  formObsSubscription!: Subscription;
  customerId: any;
  AccountHolderName: any;
  responseData: any;
  constructor(
    private formBuilder: FormBuilder,
    private router : Router,
    private readonly customerService: CustomerService,
    private readonly userService: UserService,
    private readonly route: ActivatedRoute,
    private readonly portalBuilderServices: PortalBuilderService,
    private readonly toastrMsgService: ToastrMsgService
  ) { }
  personalDetails = [
    {
      heading: 'Pay Id',
      placholder: 'Enter Your Pay ID',
    },
    {
      heading: 'Partner Name',
      placholder: 'Enter Your partner name',
  },
    {
      heading: 'First name',
      placholder: 'Enter your First Name',
    },
    {
      heading: 'Reseller ID',
      placholder: 'Enter Your reseller ID',
    },
    {
      heading: 'Last Name',
      placholder: 'Enter Your Last Name',
    },
    {
      heading: 'Industry Category',
      placholder: 'Enter Your industry category',
    },
    {
      heading: 'Business Name',
      placholder: 'Enter Your Business Name',
    },
    {
      heading: 'Email Id',
      placholder: 'Enter Your Email ID',
    },
  ];
  contactDetails = [
    {
      heading: 'Mobile',
      placholder: 'Enter Your mobile number',
    },
    {
      heading: 'Address',
      placholder: 'Enter Your address',
    },
    {
      heading: 'Telephone No ',
      placholder: 'Enter your telephone no',
    },
    {
      heading: 'State',
      placholder: 'Enter Your state',
    },
    {
      heading: 'City',
      placholder: 'Enter Your city',
    },
    {
      heading: 'Postal Code',
      placholder: 'Enter Your pstal code',
    },
  ];
  notification = [
    {
      heading: 'Customer Authentication Emailer',
      placholder: '',
    },
    {
      heading: 'Customer Transaction Emailer',
      placholder: '',
    },
    {
      heading: 'Customer Refund Emailer ',
      placholder: '',
    },
    {
      heading: 'Merchant Transaction Emailer ',
      placholder: '',
    },
    {
      heading: 'Merchant Refund Emailer ',
      placholder: '',
    },
  ];

  ngOnInit(): void {
    // this.initForm();
    this.route.params.subscribe((param: any) => {
      this.customerId = param.id;
      this.getCustomerDetails(this.customerId);
    })
  }

  // initForm() {
  // this.customerBasicForm  =  this.formBuilder.group({
  //   Title: ['', Validators.required],
  //   comments: ['', Validators.required]
  // });
  // }

  submitCustomerData() {
    this.customerService.sendCustomerFormDataEvent('send-data');
    this.formObsSubscription = this.customerService.getCustomerFormDataObsevable().subscribe((res) => {
      if(!res.validCustomerSchemeProviderForm || !res.validcustomerBusinessDetailAndUploadForm
        || !res.validcustomerBankDetailsForm) {
        this.toastrMsgService.warning('Form is invalid');
        this.formObsSubscription?.unsubscribe();
      } 
      else {
      let payload = res;
      console.log(payload)
      let apiObservable = [];
      // merge all output data from all components
      if (payload.fileData?.length) {
        for (let i = 0; i < payload.fileData.length; i++) {
          console.log(i)
          apiObservable.push(
            this.portalBuilderServices.fileUpload(
              payload.fileData[i]?.type,
              'customer',
              payload.fileData[i]
            )
          );
        }
        console.log(apiObservable)
        if (apiObservable.length) {
          forkJoin(apiObservable).subscribe((res: any) => {
            console.log(res);
            payload.document = res.map((item: any) => item.data);
            console.log(payload)
            payload = this.formatData(payload);
            console.log(payload)
            if (this.customerId) {
              this.updateCustomerData(this.customerId, payload)
            } else {
              this.createCustomer(payload)
            }
          });
        }
      }
       else {
        if (this.customerId) {
          payload = this.formatData(payload);
          console.log(payload)
          this.updateCustomerData(this.customerId, payload)
        } else {
          payload = this.formatData(payload);
          console.log(payload)
          this.createCustomer(payload)
        }
      }
    }
    })
  }


  // uploadImgAPI(type: any, folder_name: any, image: any, payload: any) {
  //   this.portalBuilderServices.fileUpload(type, folder_name, image).subscribe({
  //     next: (response: any) => {
  //       console.log(response)
  //       if(this.customerId) {
  //       console.log('upload res ', response);
  //       payload.document = response.data;
  //       payload =  this.formatData(payload);
  //       console.log(payload)
  //       this.updateCustomerData(this.customerId, payload)
  //       }
  //         else {
  //           payload =  this.formatData(payload);
  //           this.createCustomer(payload);
  //       }
  //     },
  //     error: (error) => {
  //       console.error('Error  upload state:', error);
  //     },
  //     complete: () => {
  //       console.log('upload request completed');
  //       // clean-up logic for this
  //     },
  //   });
  // }

  formatData(payload: any) {
    return {
      name: payload.name,
      // "referalId": "string",
      userId: this.customerId,
      email: payload.email ? payload.email : this.responseData?.email,
      phone: payload.phone ? payload.phone : this.responseData?.phone,
      alternatePhone: payload.alternatePhone ? payload.alternatePhone : this.responseData?.alternatePhone,
      pincode: payload.pincode ? payload.pincode : this.responseData?.pincode,
      city: {
        title: payload.city?.title ? payload.city?.title : this.responseData?.city?.title,
        cityId: payload.city?.cityId ? payload.city?.cityId :  this.responseData?.city?.cityId
      },
      state: {
        title: payload.state?.title ? payload.state?.title : this.responseData?.state?.title ,
        stateId: payload.state?.stateId ? payload.state?.stateId : this.responseData?.state?.stateId
      },
      address: payload.address ? payload.address : this.responseData?.address,
      notifyConfig: {
        smsNotify: payload.smsNotify ? payload.smsNotify : this.responseData?.notifyConfig?.smsNotify,
        emailNotify: payload.emailNotify ? payload.emailNotify : this.responseData?.notifyConfig?.emailNotify,
      },
      merchantConfig: {
        merchantIp: payload.merchantIp ? payload.merchantIp : this.responseData?.merchantConfig?.merchantIp,
        payoutWebhookUrl: payload.payoutWebhookUrl ? payload.payoutWebhookUrl : this.responseData?.merchantConfig?.payoutWebhookUrl,
      },
      settlementConfig: {
        settlementType: payload.settlementType ? payload.settlementType : this.responseData?.settlementConfig?.settlementType,
        settlementDay: payload.settlementDay ? payload.settlementDay : this.responseData?.settlementConfig?.settlementDay,
        settlementTime: payload.settlementTime ? payload.settlementTime : this.responseData?.settlementConfig?.settlementTime
      },
      bankConfig: {
        bankName: payload.bankName ? payload.bankName : this.responseData?.bankConfig?.bankName,
        ifscCode: payload.ifscCode ? payload.ifscCode : this.responseData?.bankConfig?.ifscCode,
        accountNo: payload.accountNo ? payload.accountNo : this.responseData?.bankConfig?.accountNo,
        accountHolderName: payload.accountHolderName ? payload.accountHolderName : this.responseData?.bankConfig?.accountHolderName,
        bankCurrency: payload?.bankCurrency ? payload?.bankCurrency : this.responseData?.bankConfig?.bankCurrency,
        branchName: payload.branchName ? payload.branchName : this.responseData?.bankConfig?.branchName,
        pancard: payload.bankPancard ? payload.bankPancard : this.responseData?.bankConfig?.bankPancard
      },
      businessConfig: {
        organisationType: payload.organisationType ? payload.organisationType : this.responseData?.businessConfig?.organisationType,
        businessName: payload.businessName ? payload.businessName : this.responseData?.businessConfig?.businessName,
        multicurrencyPayments: payload.multicurrencyPayments ? payload.multicurrencyPayments : this.responseData?.businessConfig?.multicurrencyPayments,
        website: payload.website ? payload.website : this.responseData?.businessConfig?.website,
        businessModel: payload.businessModel ? payload.businessModel : this.responseData?.businessConfig?.businessModel,
        address: payload.businessAddress ? payload.businessAddress : this.responseData?.businessConfig?.businessAddress,
        city: {
          title: payload.businessCity?.title ? payload.businessCity?.title : this.responseData?.businessConfig?.city?.title,
          cityId: payload.businessCity?.cityId ? payload.businessCity?.cityId : this.responseData?.businessConfig?.city?.cityId,
        },
        state: {
          title: payload.businessState?.title ? payload.businessState?.title :  this.responseData?.businessConfig?.state?.title,
          stateId: payload.businessState?.stateId ? payload.businessState?.stateId :  this.responseData?.businessConfig?.state?.stateId,
        },
        postalCode: payload.businessPostalCode ? payload.businessPostalCode :  this.responseData?.businessConfig?.businessPostalCode,
        dateOfEstablishment: payload.dateOfEstablishment ? payload.dateOfEstablishment :  this.responseData?.businessConfig?.dateOfEstablishment,
        pancard: payload.pancard ? payload.pancard : this.responseData?.businessConfig?.pancard,
        pancardName: payload.pancardName ? payload.pancardName : this.responseData?.businessConfig?.pancardName,
        cinNo: payload.cinNo ? payload.cinNo : this.responseData?.businessConfig?.cinNo,
        transactionsNo: payload.transactionsNo ? payload.transactionsNo : this.responseData?.businessConfig?.transactionsNo,
        transactionsAmount: payload.transactionsAmount ? payload.transactionsAmount : this.responseData?.businessConfig?.transactionsAmount,
        gstNo: payload.gstNo ? payload.gstNo : this.responseData?.businessConfig?.gstNo,
        industryType: payload.industryType ? payload.industryType : this.responseData?.businessConfig?.industryType,
      },
      documents: payload?.fileData ? payload?.fileData : this.responseData?.documents,
      schemeConfig: {
        schemeId: payload.schemeId,
        schemeName: payload.schemeName,
        payOut: [
           {
            name: "slab1",
            range: "1-1000",
            chargeType: payload.chargeTypeOne ? payload.chargeTypeOne :  this.responseData?.schemeConfig?.payOut[0]?.chargeType,
            fintegrator: payload.chargeFintraxOne ? payload.chargeFintraxOne :  this.responseData?.schemeConfig?.payOut[0]?.fintegrator,
            partner: payload.chargePartnerOne ? payload.chargePartnerOne :  this.responseData?.schemeConfig?.payOut[0]?.partner,
            reseller: payload.chargeResellerOne ? payload.chargeResellerOne :  this.responseData?.schemeConfig?.payOut[0]?.reseller,
            minAmount: 1,
            maxAmount: 1000 
          },
         {
            name: "slab2",
            range: "1000-25000", 
            chargeType: payload.chargeTypeTwo ? payload.chargeTypeTwo :  this.responseData?.schemeConfig?.payOut[1]?.chargeType,
            fintegrator: payload.chargeFintraxTwo ? payload.chargeFintraxTwo :  this.responseData?.schemeConfig?.payOut[1]?.fintegrator,
            partner: payload.chargePartnerTwo ? payload.chargePartnerTwo :  this.responseData?.schemeConfig?.payOut[1]?.partner,
            reseller: payload.chargeResellerTwo ? payload.chargeResellerTwo :  this.responseData?.schemeConfig?.payOut[1]?.reseller,
            minAmount: 1000,
            maxAmount: 25000
          },
          {
            name: "slab3",
            range: "25000-500000",
            chargeType: payload.chargeTypeThree ? payload.chargeTypeThree :   this.responseData?.schemeConfig?.payOut[2]?.chargeType,
            fintegrator: payload.chargeFintraxThree ? payload.chargeFintraxThree :  this.responseData?.schemeConfig?.payOut[2]?.fintegrator,
            partner: payload.chargePartnerThree ? payload.chargePartnerThree :  this.responseData?.schemeConfig?.payOut[2]?.partner,
            reseller: payload.chargeResellerThree ? payload.chargeResellerThree :  this.responseData?.schemeConfig?.payOut[2]?.reseller,
            minAmount: 25000,
            maxAmount: 500000
          },
          // 2: {
          //   chargeType: payload.chargeTypeFour,
          //   fintegrator: payload.chargeFintraxFour,
          //   partner: payload.chargePartnerFour,
          //   reseller: payload.chargeResellerFour,
          //   merchantCommission: payload.chargeMerchantFour
          // },
         
        ],
        payIn: {
          chargeType: payload.chargeType ?  payload.chargeType :  this.responseData?.schemeConfig?.payIn?.chargeType,
          reseller: payload.payInReseller ?  payload.payInReseller  :  this.responseData?.schemeConfig?.payIn?.reseller,
          partner: payload.payInPartner ?  payload.payInPartner  :  this.responseData?.schemeConfig?.payIn?.partner,
          fintegrator: payload.payInFintrax ?  payload.payInFintrax  :  this.responseData?.schemeConfig?.payIn?.fintegrator,
        }

      },
      providerConfig: {
        // providerName: "string",
        // providerId: "string",
        payOut: {
          providerName: payload.selectedProviderPayOut?.providerName ? payload.selectedProviderPayOut?.providerName : this.responseData?.providerConfig?.payOut?.providerName,
          providerId: payload.selectedProviderPayOut?._id ? payload.selectedProviderPayOut?._id : this.responseData?.providerConfig?.payOut?.providerId,
        },
        payIn: {
          providerName: payload.selectedProviderPayIn?.providerName ? payload.selectedProviderPayIn?.providerName : this.responseData?.providerConfig?.payIn?.providerName,
          providerId: payload.selectedProviderPayIn?._id ? payload.selectedProviderPayIn?._id :  this.responseData?.providerConfig?.payIn?.providerId,
        }
      }

    }
  }

  // NOT USED

  createCustomer(payload: any) {
    console.log(payload)
    this.customerService.createCustomer(payload).subscribe({
      next: res => {
        console.log(res);
        this.toastrMsgService.success('Customer Created ')
        this.formObsSubscription?.unsubscribe();
      },
      error: err => {
        this.formObsSubscription?.unsubscribe();
         console.error(err)
      },
      complete: () => console.log('Observable complete')
    })
  }

  updateCustomerData(customerId: any, payload: any) {
    console.log(payload)
    this.customerService.updateCustomer(customerId, payload).subscribe({
      next: res => {
        console.log(res)
        this.toastrMsgService.success('Customer Updated');
        this.formObsSubscription?.unsubscribe();
        this.router.navigate(['/home/customer/customerProfile']);
      },
      error: err => {
         console.error(err)
         this.formObsSubscription?.unsubscribe();
      },
      complete: () => console.log('Observable complete')
    })
  }

  getCustomerDetails(id: any) {
    this.customerService.getCustomerDetails(id).subscribe({
      next: res => {
        console.log(res);
        this.AccountHolderName = res.data.AccountHolderName;
        this.responseData = res.data;
        this.customerService.sendCustomerData(res.data);
      },
      error: err => console.error(err),
      complete: () => console.log('Observable complete')
    })
  }


  ngOnDestroy(): void {
    this.formObsSubscription?.unsubscribe();
  }

}
